import { Redirect, Route } from "react-router-dom";

const AuthProtected = (props) => {
    const token = (!sessionStorage.getItem("tokenmeetingunicorn")) ? null : sessionStorage.getItem("tokenmeetingunicorn");
    if(token === "" || token === null || typeof(token) === "undefined"){
        // window.location.replace('https://btsg.net/intranet/login.php?self=meeting-unicorn');
        return(
            <Redirect to={{ pathname: "/landing-page", state: { from: props.location } }} />
        );
    }
    return <>{props.children}</>
};

const AccessRoute = ({ component: Component, ...rest }) => {
    return (
        <Route { ...rest }
            render={props => {
                return (<> <Component {...props} /> </>);
            }}
        />
    );
};

export { AuthProtected, AccessRoute }